export const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  VERIFICATION: "/verification",
  DASHBOARD: "/dashboard",
  USERS: "/users",
  REPORTS_LOGS: "/reports-logs",
  SETTINGS: "/settings",
};
